import * as React from 'react';
import { MaterialUICore, ScheduleButton, Box } from '@iclinic/design-system';

import USER_KIND from '../constants';
import { IAButton } from './IAButton';
import { MoreButton } from './MoreButton';
import { ButtonsProps } from '../types';

const { makeStyles } = MaterialUICore;

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
  },
}));

export const NewButtons = ({
  togglePaymentsControlDrawer,
  toggleScheduleModal,
  togglePatientWaitingList,
  toggleScheduleObservation,
  printSchedule,
  openScheduleSettings,
  userData: { userKind, isAdmin, isClinicAdmin, hasSellerApproved },
  isFetching,
}: ButtonsProps): JSX.Element => {
  const classes = useStyles();

  const showSettingsButton = React.useMemo(
    () => userKind === USER_KIND.PHYSICIAN || isAdmin || isClinicAdmin,
    [userKind, isAdmin, isClinicAdmin],
  );

  return (
    <Box className={classes.root}>
      {hasSellerApproved && (
        <ScheduleButton
          onClick={togglePaymentsControlDrawer}
          icon="money"
          text="Controle de pagamento"
          idGa="agenda_controle-pagamento"
        />
      )}
      <ScheduleButton
        onClick={toggleScheduleModal}
        icon="add"
        text="Novo Agendamento"
        idGa="agenda_novo-agendamento"
      />
      <IAButton />
      <ScheduleButton
        onClick={printSchedule}
        icon="print"
        text="Imprimir Agenda"
        idGa="agenda_imprimir"
        disabled={isFetching}
      />
      <MoreButton
        togglePatientWaitingList={togglePatientWaitingList}
        toggleScheduleObservation={toggleScheduleObservation}
        openScheduleSettings={
          showSettingsButton ? openScheduleSettings : undefined
        }
      />
    </Box>
  );
};
